import React from "react"
import { GSDLogo } from "svgs"
import styles from "./footer.module.scss"
import AASULogo from "images/aasu-logo.png"

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerBlock}>
        <span className={styles.footerBlockText}>Black in Design by</span>{" "}
        <a
          href="https://harvardgsdaasu.wordpress.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.footerLogo}
        >
          <img src={AASULogo} alt="AASU" />
        </a>{" "}
        <a
          href="https://www.gsd.harvard.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.footerLogo}
        >
          <GSDLogo />
        </a>
      </div>
      <div className={styles.footerBlock}>
        <a
          className={styles.footerBlockLink}
          href="https://www.instagram.com/gsdbid_conf/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>
        <a
          className={styles.footerBlockLink}
          href="https://twitter.com/GSDBiD_Conf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Twitter
        </a>
      </div>
    </footer>
  )
}

export default Footer
